import { vb } from '@tencent/vbproxy-grpc/proto/ao_vb_loan_limit_server'
import { vb as act } from '@tencent/vbproxy-grpc/proto/ao_vb_loan_activity_server'
import { RESIDENCETYPE } from './user'

export interface IScheduleListItem {
    /** 还款本息 */
    installment: string
    /** 还款日期 */
    dueDate: string
    /** 每月还款本金 */
    periodPrcp: string
    /** 每月还款利息 */
    periodInterest: string
    /** 实际年利率 */
    yearRate?: string
}

export interface IInterestRes {
    /** 利息 */
    totInterest: string
    /** 本息 */
    installment: string
    /** 下次还款日 */
    nextRepayDate: string
    /** 当笔贷款, 上一次结息日期 */
    dueDateAlignDate: string
    /** 还款计划列表 */
    scheduleList: IScheduleListItem[]
    terms: number[]
    targetTerm: number
    apr: string
}
export interface IWithDrawRateInfo {
    monthRate: string
    overdueDayRate: string
    overdueYearRate: string
    withDrawFee: string
    withDrawFeeRate: string
    preRepayFeeRate: string
    overdueFee: string
}
export interface IInterestAndTermsRes {
    interest: IInterestRes
    discountInterest?: IInterestRes
    discountRateInfo: IWithDrawRateInfo
    withDrawRateInfo: IWithDrawRateInfo
    couponId: string
    couponDayRate: string
    couponYearRate: string
    couponMonthRate: string
    couponRateType: number
    couponList: act.loan.ao.activity.ICouponInfo[]
    rateInfo: {
        newRateIsHigher: boolean
        oldApr: string
        newApr: string
        oldDayRate: string
        newDayRate: string
    }
}

interface IUserLimitExtInfo {
    /** 是否可提额 */
    can_increase_limit: string
    /** 提额上限 */
    increase_upper_limit: string
}

export interface IUserLimitInfo {
    /** 审批的时间 */
    approvalDate?: number
    /** 总的额度 */
    limit: string
    /** 剩余额度 */
    limitLeft: string
    /** 授信额度 */
    creditAmt: string
    /** 年利率 */
    yearRate: string
    /** 日利率 */
    dayRate: string
    /** 币种 */
    ccyCode: string
    /** 额度编号 */
    limitNo: string
    /** 额度状态 0代表还没申请过额度 2代表正常状态 3代表额度冻结 4 代表额度过期 */
    status: number
    /** 平息利率 */
    interestRate: string
    /** 逾期利率 */
    overdueRate: string
    /** 逾期月利率 */
    overdueMonthRate: string
    /** 用户确认额度的最大天数 */
    confirmDay?: number
    /** 确认额度时间（表示用户需在额度审批后多少天内确认 目前使用配置值） */
    remain_confirm_day?: number
    /** 产品编号 */
    product_no?: string
    /** 产品编号 */
    product_type?: number
    /** 产品唯一类型定义 */
    uniqueType?: IProductUniqueTypes
    /** 额度是生效中 */
    isValid?: number
    extInfo: IUserLimitExtInfo
    /** 记录业务流水号 */
    seq?: string
    /** 记录创建时间 */
    createTime?: number
    /** 记录最后更新时间 */
    lastupdateTime?: number
    /** 平台，-1:默认，0:IOS，1:Android，2:H5 */
    platform?: number
    /** 居民类型 */
    residentType: number
    /** 额度有效时间 */
    limitValidTime?: number
    /** 到期提醒提前时间 */
    expireDay?: number
    pendingExpireDay?: number
    uid?: string
    productTag: string
    userLimitInfoExtInfo: {
        senceId: string
        unfreeze_time: number
    },
    creditNote?: {
        declareIncomeGetlimit: string
        /** 永居用户地址或者车主证明后置 为1 代表后置 */
        proofAddressInback: string
        /** 是否要展示资产授信入口 */
        propertyAllow: string
        /** 是否优质客户 */
        userIsHighquality: string
        approve_limit?: string // 授予的额度
        userdeclare_limit?: string // 用户声明额度
        user_oper_tips?: string // 用户操作提示：can_adjustlimit:可调额
        limit_adjust_step?: string // 额度调整步长，暂定1000
        user_cancel_increase?: string // 用户取消额度
        manual_carowner?: string // 车主证明上传标志
    }
}

export interface IProduct {
    /** 产品名 */
    name: string
    /** 产品业务编号 */
    proNo: string
    /** 永居产品可贷的期数 */
    proLoanTerm: string[]
    /** 非永居产品可贷的期数 */
    proLoanTermNoResidence: string[]
    /** 币种 */
    ccyCode: string
    /** 还款方式 */
    rpyMethod: string
    /** 核心产品号 */
    baseProNo: string
    /** 最小需要贷款的金额 */
    minLoanAmt: string
    /** 产品状态 3为产品下架 否则正常 */
    proStatus: number
    /** 非永居默认贷款期数 */
    termsNoResidenceDefaultTerm: string
    productTag: string
    /** 永居默认贷款期数 */
    termsResidenceDefaultTerm: string

    extInfo: {
        limit_max: string
        limit_min: string
        rate_max: string
        rate_min: string
        can_multi_drawdown?: number
        month_rate?: string
        charge_fee?: {
            apply_fee_ratio: string
            overdue_fee_no: string
            pre_repay_fee_no: string
        }
    }
    uniqueType?: IProductUniqueTypes
}

export interface IProductRes {
    proList: IProduct[]
}

export interface IGetInterestQuery {
    couponId?: string
    month: string
    amount: string
    ccyCode: string
    proNo: string
    rate: string
    rpyMethod: string
    loanType?: number
    isActivity: string
    dueDateAlignDate: string
    nextRepayDate: string
}

export interface IGetTermsRes {
    terms: number[]
    availableInstallment: string
    availableLimit: string
    totalInstallment: string
    maxTerm: number
}

export interface IGetTermsQuery {
    limitCode: string
    principal: string
    prodId: string
    seq: string
}

export interface ITermsAndInterestReq {
    couponId?: string
    month?: string
    ccyCode: string
    loanNo: string
    prodId: string
    productTag: string
    amount: string
    inputAmt: string
    yearRate: string
    dayRate: string
    rpyMethod: string
    loanType?: number
    isActivity: string
    lastSelectTerm: string
    nextRepayDate: string
    dueDateAlignDate: string
    notUseCoupon: string
    seq: string
    entrustCouponInvalid: '1' | '0'
}

export interface IRequireReq {
    prodId: string
}

export interface ICheckUserLimitReq {
    prodId: string
    seq: string
    /** 正常情况下地址证明后置下提额场景 状态为0，工单接口没返回用户该上传什么工单，这里添加一个标志 让工单接可以检查该需要上传什么工单 */
    increaseLimitScene?: '1' | '0'
}

export interface ICheckCreateLimitData {
    allowApplyTimeStr: string
    seq: string
}

export interface ICreateLimitCheckReq {
    productNo: string
}

export interface ICheckUserLimitData {
    manual_result: vb.loan.ao.limit.IManualApprovalResult[]
    applyTime: number
    applyDueTime: number
    limit_seq: string
    limit_status: string
    resident_type: number
    confirmDay: number
    uploadProofValidDay: number
    approvalDate: number
    creditAmt: string
    ccyCode: string
    extInfo: {
        can_increase_limit: string
    }
    userLimitInfoExtInfo: {
        /** 标志哪个场景id进入 */
        senceId: string
    }
    creditNote: {
        /** Y表示进入人工收入 */
        manualIncome: string
        /** 提额情况下是否允许资产证明 Y代表允许 状态为18的情况下 或者是有提额条件下才可以去判断 */
        userIsHighquality: string

        /** 是否允许资产证明 Y代表允许 */
        propertyAllow: string
        /** 非永居用户声明收入获得额，也就是贷前审批的时候可以先看到的额度 */
        declareIncomeGetlimit: string
        /** 永居用户证明后置（包括车主后置或者地址后置或者两者都后置） 为1 代表可以后置 */
        proofAddressInback: string
        /** 初始额度 */
        approveLimit: string
        /** 地址证明手动修改，有值才展示修改地址 */
        tuAddressBuildingcode: string
    }
}

export interface ICreateLimitCheckRsp {
    allowCreateLimit?: boolean
    allowTime?: number
    allowTimeFormat?: string
    check_res?: number
    check_desc?: string
    userRejectTime?: string
    allowApplyTime?: string
}

export interface IGetUserLimitInfoListReq {
    /**
     * 业务商品编号，可选,如果有多个商品请用英文逗号“,”隔开
     */
    productNo?: string
    /**
     * 额度状态筛选，可选,如果有多个商品请用英文逗号“,”隔开
     */
    status?: string
    seq?: string
}

export interface IGetUserLimitInfoListResp {
    list: IUserLimitInfo[]
    limitUniqueStatus: ILimitUniqueStatus
    userInfo: {
        residentType: RESIDENCETYPE
        acctNo: string
        uid: string
    }
}

export enum IProductUniqueTypes {
    /** NPP产品 */
    NPP = 1,
    /** Tesla产品 */
    TESLA = 2,
    /** 未具体定义 */
    UNKNOWN = 0,
}

export enum ILimitUniqueStatus {
    /** 没有任何额度信息 */
    NO = 1,
    /** NPP产品有效额度 */
    NPP = 2,
    /** Tesla产品有效 */
    TESLA = 3,
}

export const ProductUniqueTypeMap: { [key: string]: any } = {
    FyvFkIqLYfHM3ju: IProductUniqueTypes.NPP,
    tesla_realKHMw3ju: IProductUniqueTypes.TESLA,
}

export enum ProductList {
    NPP = 'FyvFkIqLYfHM3ju',
    TESLA = 'tesla_realKHMw3ju',
}

export interface IGetQuickTransferInfoReq {
    /** 贷款商品ID */
    productNo: string
}
export interface IQuickTransferInfoResp {
    /** FPS ID */
    fpsId: string
    /** 转账附言 */
    tradeRemark: string
    /** 跳转链接文案 */
    linkText: string
}

export interface IUserApplyIncreaseLimitReq {
    productNo: string
}
export interface ICheckLimitExclusionResp {
    isExclusion: boolean
}
export interface IUserCancelIncreaseLimitReq {
    prodId: string
    seq: string
}

export interface IUserCheckCancelIncreaseLimitRep {
    canCancelIncrease: number
}

export interface ICheckEprcAddressReq {
    prodId: string
    seq: string
    operType: number // 0: 核验地址；1：修改地址
}
